module.exports = __webpack_public_path__ + "img/right_md_4.52d171b9.jpg";